import React from "react";
import ReactDOM from "react-dom";
import { Marker } from "./types";

export const Map = ({
  markers,
  setActiveItem,
  ymaps3Reactify,
}: {
  markers: Marker[];
  setActiveItem: Function;
  ymaps3Reactify: any;
}) => {
  const reactify = ymaps3Reactify.reactify.bindTo(React, ReactDOM);
  const { YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker } =
    reactify.module(ymaps3);
  return (
    <div className="h-96 pb-5">
      <YMap
        location={{
          center: [44.006516, 56.326797],
          zoom: 10,
          duration: 300,
        }}
        mode="vector"
      >
        <YMapDefaultSchemeLayer />
        <YMapDefaultFeaturesLayer />

        {markers.map((item, key) => {
          return (
            <YMapMarker
              key={key}
              hideOutsideViewport={true}
              coordinates={item.coord}
            >
              <div
                onClick={() => {
                  setActiveItem(item);
                }}
                className="h-8 w-8 absolute -left-4 -top-4 bg-gray-800 flex items-center justify-center rounded-full cursor-pointer"
              >
                <img src="/img/skb-icon.svg" className="w-4/6" />
              </div>
            </YMapMarker>
          );
        })}
      </YMap>
    </div>
  );
};
